import { useState } from 'react';
import apiClient from '../../utils/api';

const AdminUserAccessPanel = ({ addToast, standalone = false }) => {
  const [email, setEmail] = useState("");
  const [user, setUser] = useState(null);
  const [busy, setBusy] = useState(false);
  const [blockReason, setBlockReason] = useState("");

  const lookup = async () => {
    const q = email.trim();
    if (!q) {
      addToast("Enter an email address.", "error");
      return;
    }
    setBusy(true);
    setUser(null);
    try {
      const res = await apiClient.lookupUserByEmail(q);
      setUser(res.data || null);
      if (!res.data) addToast("No user found.", "info");
    } catch (err) {
      addToast(err.message || "Lookup failed", "error");
    } finally {
      setBusy(false);
    }
  };

  const block = async () => {
    if (!user?.uid) return;
    if (!window.confirm(`Block ${user.email}? They will not be able to sign in or use the API.`)) return;
    setBusy(true);
    try {
      const res = await apiClient.blockPlatformUser(user.uid, blockReason);
      setUser(res.data || null);
      addToast("User blocked from the platform.", "success");
    } catch (err) {
      addToast(err.message || "Block failed", "error");
    } finally {
      setBusy(false);
    }
  };

  const unblock = async () => {
    if (!user?.uid) return;
    if (!window.confirm(`Unblock ${user.email}?`)) return;
    setBusy(true);
    try {
      const res = await apiClient.unblockPlatformUser(user.uid);
      setUser(res.data || null);
      addToast("User unblocked.", "success");
    } catch (err) {
      addToast(err.message || "Unblock failed", "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={standalone ? undefined : { marginTop: "2.5rem", paddingTop: "2rem", borderTop: "1px solid var(--border)" }}>
      <div className="admin-panel-head">
        <div>
          <h3><i className="fas fa-user-slash"></i> {standalone ? "User access management" : "Block platform access"}</h3>
          <p className="admin-panel-sub">
            Disables Firebase sign-in and blocks API access. Use for fraud or abuse. Admins cannot be blocked.
          </p>
        </div>
      </div>
      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", marginBottom: "1rem" }}>
        <input
          type="email"
          placeholder="user@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ flex: "1 1 220px", padding: "0.6rem 0.75rem", borderRadius: 8, border: "1px solid var(--border)" }}
        />
        <button type="button" className="btn btn-outline btn-sm" onClick={lookup} disabled={busy}>
          Look up user
        </button>
      </div>
      {user && (
        <div className="agent-card">
          <p style={{ margin: "0 0 0.5rem" }}>
            <strong>{user.firstName} {user.lastName}</strong> · {user.email}
          </p>
          <p style={{ margin: "0 0 1rem", fontSize: "0.85rem", color: "var(--text-light)" }}>
            Role: {user.role || "investor"} · Account:{" "}
            <strong style={{ color: user.isActive === false ? "var(--danger)" : "var(--success)" }}>
              {user.isActive === false ? "Blocked" : "Active"}
            </strong>
            {" · "}KYC:{" "}
            <strong style={{
              color: user.kycStatus === "approved" ? "var(--success)" : user.kycStatus === "rejected" ? "var(--danger)" : "var(--warning)",
            }}>
              {user.kycStatus === "approved" ? "Verified" : user.kycStatus === "rejected" ? "Rejected" : "Unverified"}
            </strong>
          </p>
          {user.isActive !== false ? (
            <>
              <div className="form-group" style={{ marginBottom: "0.75rem" }}>
                <label style={{ fontSize: "0.8rem" }}>Reason (optional)</label>
                <input
                  type="text"
                  value={blockReason}
                  onChange={(e) => setBlockReason(e.target.value)}
                  placeholder="e.g. duplicate fraudulent listings"
                  style={{ width: "100%", padding: "0.5rem 0.65rem", borderRadius: 8, border: "1px solid var(--border)" }}
                />
              </div>
              <button type="button" className="btn btn-sm" style={{ background: "var(--danger)", color: "#fff" }} onClick={block} disabled={busy}>
                Block user
              </button>
            </>
          ) : (
            <button type="button" className="btn btn-primary btn-sm" onClick={unblock} disabled={busy}>
              Unblock user
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminUserAccessPanel;
